import React from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { createTheme, getDesignTokens, Paper, ThemeProvider, Typography } from "@platform/style";

export const IceLogout = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const theme = createTheme(getDesignTokens("light"));

  React.useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) {
      auth.clearStaleState().then(() => auth.removeUser().then(() => auth.signoutRedirect()));
    } else if (!auth.isLoading && !auth.isAuthenticated) {
      navigate("/auth/login");
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "15%",
          backgroundColor: "background.default",
        }}
      >
        <Typography variant={"body1"}>Logging out...</Typography>
      </Paper>
    </ThemeProvider>
  );
};
